export default "__VITE_ASSET__BHxTzDRp__"